import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { AccountImpl } from "../model/impl/AccountImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class AccountImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: AccountImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.clientId != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        AccountImplEncoder.fidTypeMap.get(1),
        false,
        encodable.clientId,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.bookingCode != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        AccountImplEncoder.fidTypeMap.get(2),
        false,
        encodable.bookingCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.bookingType != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        AccountImplEncoder.fidTypeMap.get(3),
        false,
        encodable.bookingType,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.id != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        AccountImplEncoder.fidTypeMap.get(4),
        false,
        encodable.id,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.name != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        AccountImplEncoder.fidTypeMap.get(5),
        false,
        encodable.name,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.creditCheckFg != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        AccountImplEncoder.fidTypeMap.get(6),
        false,
        encodable.creditCheckFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.contact != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        AccountImplEncoder.fidTypeMap.get(7),
        false,
        encodable.contact,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.salesGroupId != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        AccountImplEncoder.fidTypeMap.get(8),
        false,
        encodable.salesGroupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.ordersEnabledFg != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        AccountImplEncoder.fidTypeMap.get(9),
        false,
        encodable.ordersEnabledFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.clientAutoFillEnabled != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        AccountImplEncoder.fidTypeMap.get(10),
        false,
        encodable.clientAutoFillEnabled,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.associatedClients != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        true,
        AccountImplEncoder.fidTypeMap.get(11),
        false,
        encodable.associatedClients,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        AccountImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,AccountImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.lang.String"],
    [3, "com.bcdfx.model.AccountBookingType"],
    [4, "java.lang.String"],
    [5, "java.lang.String"],
    [6, "java.lang.Boolean"],
    [7, "java.lang.String"],
    [8, "java.lang.Long"],
    [9, "java.lang.Boolean"],
    [10, "java.lang.Boolean"],
    [11, "java.lang.String"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: AccountImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AccountImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.clientId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AccountImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.bookingCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: CubiqTS.AccountBookingType = this.baseEncoder.readObject(
            false,
            false,
            AccountImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.bookingType = <CubiqTS.AccountBookingType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AccountImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.id = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AccountImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.name = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            AccountImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.creditCheckFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AccountImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.contact = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            AccountImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.salesGroupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            AccountImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.ordersEnabledFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            AccountImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.clientAutoFillEnabled = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            AccountImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.associatedClients = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AccountImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,AccountImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return AccountImplEncoder.fidTypeMap.has(fid);
  }
}
